<template>
  <div>
    <div class="tab-options">
      <router-link v-for="(data, index) in options" :key="index"
            :to="({name: data.route})"
            :class="{'tab-highlight': $route.name === data.route}">
        {{data.name}}
      </router-link>
    </div>

    <unprivilege-panel
      v-if="unprivilegeSections.includes(getterUnprivilegePage)"
      :css="'settings-panel'"
    />
    <pg-status
      v-else-if="showPgStatus"
    />
    <router-view v-else />
  </div>
</template>

<script>
import UnprivilegePanel from '@/components/global/UnprivilegePanel'
import PgStatus from '@/components/PG/Status'

import { mapGetters } from 'vuex'

export default {
  name: 'SectionTabsLayout',
  components: { UnprivilegePanel, PgStatus },
  data () {
    return {
      options: [],
      unprivilegeSections: ['UPIs', 'UPI Collections', 'Configure UPI', 'Pending Approval', 'UPI Details', 'Invalid Credits', 'Virtual Accounts', 'VA Connected Banking', 'UPI Connected Banking', 'PG Orders', 'PG Refunds'],
      showPgStatus: false
    }
  },
  watch: {
    '$route': {
      handler: 'updateTabs',
      immediate: true
    },
    getterVaConnectedBanking () {
      this.updateVaOptions()
    },
    getterUpiConnectedBanking () {
      this.updateUpiOptions()
    },
    getterPgStatus () {
      if (this.$route.path.startsWith('/pg')) {
        this.updatePgOptions()
      }
    }
  },
  computed: {
    ...mapGetters(['getterUnprivilegePage', 'getterVaConnectedBanking', 'getterUpiConnectedBanking', 'getterPgStatus'])
  },
  methods: {
    updateTabs () {
      const path = this.$route.path

      if (path.startsWith('/upis')) {
        this.options = [
          {
            name: 'List',
            route: 'UPIList'
          },
          {
            name: 'Collections',
            route: 'UPICollections'
          },
          {
            name: 'Invalid Credits',
            route: 'UPIInvalidCredits'
          }
        ]
        this.updateUpiOptions()
      } else if (path.startsWith('/pg')) {
        this.updatePgOptions()
      } else {
        this.options = [
          {
            name: 'List',
            route: 'VAList'
          },
          {
            name: 'Invalid Credits',
            route: 'VAInvalidCredits'
          }
        ]
        this.updateVaOptions()
      }
    },
    updateVaOptions () {
      if (this.getterVaConnectedBanking) {
        this.options.push({
          name: 'Connected Banking',
          route: 'VAConnectedBanking'
        })
      } else {
        this.options = this.options.filter(e => e.route !== 'VAConnectedBanking')
      }
    },
    updateUpiOptions () {
      if (this.getterUpiConnectedBanking) {
        this.options.push({
          name: 'Connected Banking',
          route: 'UPIConnectedBanking'
        })
      } else {
        this.options = this.options.filter(e => e.route !== 'UPIConnectedBanking')
      }
    },
    updatePgOptions () {
      this.checkPgStatus()

      if (!this.showPgStatus) {
        this.options = [
          {
            name: 'Orders',
            route: 'Orders'
          },
          {
            name: 'Refunds',
            route: 'Refunds'
          }
        ]
      }
    },
    checkPgStatus () {
      this.showPgStatus = this.getterPgStatus !== 'active'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/tabOptions.scss';
</style>
